import { Component, Input, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataInputPlanDevices } from 'src/app/models/DataInputPlanDevices.model';
import { MasterDataDTO } from 'src/app/models/MasterDataDTO.model';
import { MasterdataRequestDTO } from 'src/app/models/MasterdataRequestDTO.model';
import { PlanByUserDTO } from 'src/app/models/PlanByUserDTO.model';
import { PlanDTO } from 'src/app/models/PlanDTO.model';
import { UserPlanDevDTO } from 'src/app/models/UserPlanDevDTO.model';
import { AssignPlanService } from 'src/app/services/assign-plan.service';
import { CustomerService } from 'src/app/services/customer.service';
import { PlanService } from 'src/app/services/plan.service';
import { Alert } from 'src/app/shared/models/Alert';
import { ResponseDataFile } from 'src/app/shared/models/ApiResponse';
import { SimpleRequestString } from 'src/app/shared/models/SimpleRequestString';
import { UserRequestDTO } from 'src/app/shared/models/UserRequestDto';
import { AlertService } from 'src/app/shared/services/alert.service';
import { saveAs } from 'file-saver';
import { PaginationService } from 'src/app/shared/services/pagination.service';
import { SimpleValueDecimal } from 'src/app/models/SimpleValueDecimal.model';
import { BillingService } from 'src/app/services/billing.service';
import { ResponseBase } from 'src/app/models/ResponseBase';

import { UserPlanHistoryDTO } from 'src/app/models/UserplanHistory/UserPlanHistoryDTO';
import { TableColumn } from 'src/app/models/TableColumn';
import { UserPlanHistoryRequest } from 'src/app/models/UserplanHistory/UserPlanHistoryRequest';
import { CustomerPlanSummaryDTO } from 'src/app/models/CustomerPlanSummaryDTO.model';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableControlComponent } from '../../../shared/controls/table-control/table-control.component';
import { TooltipDirective } from '../../../directives/tooltip.directive';
import { ValidateDecimalsDirective } from '../../../directives/validate-decimals.directive';
import { SearchPipe } from '../../../pipes/search.pipe';
import { PermissionService } from '../../../services/permission.service';
import { ValidatePermissionsService } from '../../../shared/services/validate-permissions.service';
declare var bootstrap: any;

@Component({
    selector: 'app-list-customer-plans',
    templateUrl: './list-customer-plans.component.html',
    styleUrls: ['./list-customer-plans.component.css'],
    imports: [
        CommonModule,
        FormsModule,
        TableControlComponent,
        TooltipDirective,
        ValidateDecimalsDirective,
        SearchPipe
    ]
})
export class ListCustomerPlansComponent implements OnChanges {
  @Input() customerDataInput: any;
  information: string = 'Update Plan';
  planSelected?: number = 0;
  plansCustomer: PlanByUserDTO[] = [];
  filteredPlansCustomer: any[] = [];
  textoBusqueda: string = '';
  discount?: number = undefined;
  typeDiscount?: string = "";
  listTipeDiscount: MasterDataDTO[] = [];
  dateValidFrom?: string = undefined;
  dateValidUntil?: string = undefined;
  fieldsCompleted: boolean = false;
  description?: string = '';
  plans: PlanDTO[] = [];
  camposBusqueda: string[] = [
    'planDescription',
    'description',
    'price',
    'allowance',
    'currentConsumtion',
  ];
  isFilteredByStatus: boolean = false;
  originalPlans: PlanByUserDTO[] = [];
  selectedPlanDev: PlanByUserDTO | any = {} as PlanByUserDTO;
  dataInputPlanDevices: DataInputPlanDevices = {} as DataInputPlanDevices;
  isConfirmationModalOpen: boolean = false;
  customerData: any;
  userRequestDTO: UserRequestDTO = {
    userId: undefined,
  };
  masterdataRequestDTO: MasterdataRequestDTO = {
    idMaster: 3,
  };

  userPlanDev: UserPlanDevDTO = {} as UserPlanDevDTO;
  requestTypePlan: SimpleRequestString = {} as SimpleRequestString;
  renovationChecked = false;
  transferChecked = false;
  alert: Alert = {} as Alert;
  prorationFinal?: number = undefined;
  isValidProrating: boolean = false;

  userPlanHistoryData: UserPlanHistoryDTO[] = []

  columns: TableColumn[] = [
    {
      key: 'dateCreated', header: 'Transaction Date',
      format: {
        type: 'date',
        dateFormat: 'MM/dd/yyyy hh:mm:ss a'
      }
    },
    { key: 'description', header: 'Description', width: 200 },
    { key: 'discount', header: 'Discount' },
    { key: 'typeDiscount', header: 'Type Discount' },
    {
      key: 'validFrom', header: 'ValidFrom',
      format: {
        type: 'date',
        dateFormat: 'MM/dd/yyyy'
      }
    },
    {
      key: 'validUntil', header: 'Valid Until',
      format: {
        type: 'date',
        dateFormat: 'MM/dd/yyyy'
      }
    },
    { key: 'renovation', header: 'Is Renovation' },
    { key: 'transferData', header: 'Has Data Transfer' },

    { key: 'initialDataPlanMb', header: 'Initial Data Plan Mb' },
    { key: 'activationDate', header: 'Activation Date',
       format: {
        type: 'date',
        dateFormat: 'MM/dd/yyyy'
      }
     },
    { key: 'alertSendPercentage', header: 'Threshold Alert Percentage',
      format: {
      type: 'percent',
      decimalPlaces: 1
    }
     },
    { key: 'prorationInitial', header: 'Initial Proration' },
    { key: 'prorationEnd', header: 'Ending Proration' },


    { key: 'modifiedByUserId', header: 'Modified By' },
  ];

  listOfPlans: CustomerPlanSummaryDTO[] = []


  constructor(
    private customerService: CustomerService,
    private router: Router,
    private route: ActivatedRoute,
    private plansService: PlanService,
    private alertService: AlertService,
    private assignPlanService: AssignPlanService,
    public paginationService: PaginationService,
    public permissionService: ValidatePermissionsService,
    private billingService: BillingService,
  ) { }

  ngOnChanges(c: any) {
    if (c.customerDataInput) {
      if (this.userRequestDTO.userId !== this.customerDataInput.userId) {
        this.userRequestDTO.userId = this.customerDataInput.userId;
        this.loadCustomerPlans();
      }
    }
  }

  ngOnInit() {
    if (this.userRequestDTO.userId !== this.customerDataInput.userId) {
      this.userRequestDTO.userId = this.customerDataInput.userId;
      this.loadCustomerPlans();
    }

    this.assignPlanService.getMastersById(this.masterdataRequestDTO).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleGetMastersById(Data)
          : this.handleError(StatusCode),
      (error) => {
        this.clearFields();
      }
    );
  }

  private loadCustomerPlans() {
    this.customerService.getPlansByUserId(this.userRequestDTO).subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.HandleGetListCustomers(Data);
        } else {
          this.HandleGetListCustomersError(StatusCode);
        }
      },
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
      }
    );
  }

  handleError(statusCode: number) {
    this.clearFields();
  }

  handleGetMastersById(data: MasterDataDTO[]) {
    this.listTipeDiscount = data;
  }

  clearFields() {
    this.planSelected = undefined;
    this.discount = undefined;
    this.typeDiscount = '';
    this.dateValidFrom = undefined;
    this.dateValidUntil = undefined;
    this.description = '';
    this.selectedPlanDev = {} as PlanByUserDTO;
  }

  clearChecks() {
    //this.renovationChecked = false;
    //this.transferChecked = false;
  }

  checkFields() {

    if (this.discount) {
      this.fieldsCompleted =
        this.planSelected != undefined &&
        this.typeDiscount != ""
    }
    else {
      this.fieldsCompleted =
        this.planSelected != undefined;
      this.typeDiscount = ""
    }

    if (this.typeDiscount === '1' && this.discount !== undefined) {
      if (this.discount < 0 || this.discount > 100) {
        this.discount = undefined;
      }
    }

    if (this.typeDiscount === '1' && this.discount !== undefined) {
      if (this.discount < 0 || this.discount > 100) {
        this.discount = undefined;
      }
    }

    if (!this.dateValidFrom) {
      this.fieldsCompleted = false;
    }

    if (this.dateValidFrom && this.dateValidUntil) {
      if (new Date(this.dateValidFrom) >= new Date(this.dateValidUntil)) {
        this.dateValidUntil = "";
      }
    }

    if (this.planSelected == 0) {
      this.fieldsCompleted = false;
    }

    this.prorationFinal = undefined;
  }

  get pages(): number[] {
    return this.paginationService.pages;
  }

  changePage(page: number) {
    this.paginationService.changePage(page);
    this.filteredPlansCustomer = this.paginationService.updatePagination(
      this.plansCustomer, this.textoBusqueda, this.camposBusqueda
    );
  }

  previousPage() {
    this.paginationService.previousPage();
    this.filteredPlansCustomer = this.paginationService.updatePagination(
      this.plansCustomer, this.textoBusqueda, this.camposBusqueda
    );
  }

  nextPage() {
    this.paginationService.nextPage(this.filteredPlansCustomer.length);
    this.filteredPlansCustomer = this.paginationService.updatePagination(
      this.plansCustomer, this.textoBusqueda, this.camposBusqueda
    );
  }

  getRange(): string {
    return this.paginationService.getRange(this.filteredPlansCustomer.length);
  }

  HandleGetListCustomersError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    //localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
  }

  HandleGetListCustomers(plansCust: PlanByUserDTO[]) {
    this.plansCustomer = plansCust;
    this.originalPlans = this.plansCustomer.slice();
    this.plansCustomer = this.originalPlans.filter((plan) => plan.status === 0 || plan.status === 1);


    // Llama al servicio para filtrar y paginar los datos
    this.filteredPlansCustomer = this.paginationService.updatePagination(
      this.plansCustomer, this.textoBusqueda, this.camposBusqueda
    );

    // Reinicia la paginación a la primera página
    this.paginationService.currentPage = 1;
  }

  onSearchChange(): void {
    this.filteredPlansCustomer = this.paginationService.updatePagination(
      this.plansCustomer, this.textoBusqueda, this.camposBusqueda
    );
  }

  filterByStatus(status: number) {
    this.plansCustomer = this.originalPlans.slice(); // Restaura la lista original
    if (!this.isFilteredByStatus) {
      // Guarda la lista original si no se ha filtrado aún
      this.originalPlans = this.plansCustomer.slice();
      this.isFilteredByStatus = true;
    }

    this.plansCustomer = this.originalPlans.filter((plan) => plan.status === status);
    this.filteredPlansCustomer = this.paginationService.updatePagination(
      this.plansCustomer, this.textoBusqueda, this.camposBusqueda
    );
  }

  clearFilter() {
    this.isFilteredByStatus = false;
    this.plansCustomer = this.originalPlans.slice(); // Restaura la lista original
    this.plansCustomer = this.plansCustomer.filter(plan => plan.status === 0 || plan.status === 1);
    this.filteredPlansCustomer = this.paginationService.updatePagination(
      this.plansCustomer, this.textoBusqueda, this.camposBusqueda
    );
  }

  setSelectedCustomer(plan: PlanByUserDTO) {
    this.selectedPlanDev = plan;
  }


  setUpdatePlan(plan: PlanByUserDTO) {
    this.selectedPlanDev = plan;
    this.requestTypePlan.value = plan.typePlan;
    //console.log(plan.typePlan);
    this.planSelected = plan.planId;
    this.discount = plan.discountOnlyNumber;
    this.typeDiscount = plan.idMasterTypeDiscount;

    if (plan.validFrom != null) {
        //this.dateValidFrom = plan.validFrom.split('T')[0];
        this.dateValidFrom = new Date(plan.validFrom).toLocaleDateString('en-CA');

    }

    if (plan.validUntil != null) {
        //this.dateValidUntil = plan.validUntil.split('T')[0];
        this.dateValidUntil = new Date(plan.validUntil).toLocaleDateString('en-CA');
    }

    this.description = plan.description;

    const request: UserPlanHistoryRequest = {
      planId: plan.planId,
      userId: plan.userId
    }

    this.customerService.GetUserPlanHistory(request).subscribe(
      (reponse) => {
        
        this.userPlanHistoryData = reponse.history;
      },
      (error) => {
        this.clearFields();
      }
    );
    this.plansService.getAllPlansTypePlan(this.requestTypePlan).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleGetAllPlansAssignPlan(Data)
          : this.handleError(StatusCode),
      (error) => {
        this.clearFields();
      }
    );
  }

  toggleStatus(event: any, plan: PlanByUserDTO) {
    plan.status = event.target.checked ? 1 : 0;
    const indice = this.originalPlans.findIndex(
      (plan) => plan.userId === plan.userId
    );
    if (indice !== -1) {
      this.originalPlans[indice].status = plan.status;
    }
  }

  setArchivedCustomerPlan(plan: PlanByUserDTO) {
    this.selectedPlanDev = plan;
    //this.selectedPlanDev.status = 2;
    this.selectedPlanDev['@status'] = this.selectedPlanDev.status === 2 ? 1 : 2;
    //console.log(this.selectedPlanDev);
  }

  // Метод обновления статуса клиента
  updateUserPlanStatus(confirmed: boolean) {
    if (confirmed) {
      //console.log(this.selectedPlanDev);
      if (typeof this.selectedPlanDev['@status'] === 'number') this.selectedPlanDev.status = this.selectedPlanDev['@status'];
      this.customerService.updateUserPlanStatus(this.selectedPlanDev).subscribe(
        ({ StatusCode, Message, Data }) => {
          if (Data != null) {
            this.HandleUpdateCustomerStatus(Data);
          } else {
            this.HandleUpdateCustomerStatusError(StatusCode);
          }
        },
        (error) => {
          console.error('Unexpected error fetching customer list:', error);
        }
      );
    } else {
      location.reload();
    }
  }

  openConfirmationModal(plan: any) {
    this.selectedPlanDev = plan;
    this.isConfirmationModalOpen = true;
  }

  async closeConfirmationModal() {
    this.isConfirmationModalOpen = false;
    await this.refreshPlanData();
  }

  refreshPlanData() {
    this.customerService.getPlansByUserId(this.userRequestDTO).subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.HandleGetListCustomers(Data);
        } else {
          this.HandleGetListCustomersError(StatusCode);
        }
      },
      (error) => {
        console.error('Error fetching customer plans:', error);
      }
    );
  }


  HandleUpdateCustomerStatusError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    //localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
  }

  async HandleUpdateCustomerStatus(customer: boolean) {
    this.alert = {
      alertMessage: 'Customer Plan status updated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
    location.reload();
  }

  navigateToCustomerPlans(plan: PlanByUserDTO) {
    this.dataInputPlanDevices.customerId = this.customerDataInput.userId;
    this.dataInputPlanDevices.customerName = this.customerDataInput.userNames;
    this.dataInputPlanDevices.planID = plan.idusrplndev;
    this.dataInputPlanDevices.planName = plan.planDescription;
    this.router.navigate(['/customers/plan-devices'], {
      relativeTo: this.route,
      state: { dataInputPlanDevice: this.dataInputPlanDevices },
    });
  }

  updatePlan(confirmation: boolean) {

    if (confirmation) {
      this.userPlanDev.aUserPlanId = this.selectedPlanDev.idusrplndev;
      this.userPlanDev.aPlanId = this.planSelected !== undefined ? parseInt(this.planSelected.toString()) : undefined;
      this.userPlanDev.aDiscount = this.discount != null ? parseFloat(this.discount.toString().replace(/[\$,]/g, '').replace(/\,/g, '.')) : undefined;
      this.userPlanDev.aTypeDiscount = this.typeDiscount;
      this.userPlanDev.aValidFrom = this.dateValidFrom !== undefined ? new Date(this.dateValidFrom) : undefined;
      this.userPlanDev.aValidUntil = this.dateValidUntil !== undefined ? new Date(this.dateValidUntil) : undefined;
      this.userPlanDev.aDescription = this.description;
      this.userPlanDev.aDeviceId = undefined;
      this.userPlanDev.aUserId = this.selectedPlanDev.userId;
      this.userPlanDev.renovationChecked = this.renovationChecked;
      this.userPlanDev.transferDataChecked = this.transferChecked;
      this.userPlanDev.prorationEnd = this.prorationFinal;

      this.assignPlanService.updateUserPlan(this.userPlanDev).subscribe(
        (response) => {

          this.handleUpdatePlanSuccess(response)

        },

        (error) => {
          this.clearFields();
        }
      );
    }
    else {
      this.clearChecks();
    }
  }

  async handleUpdatePlanSuccess(data: ResponseBase) {
    if (data.validationErrorMessage) {
      this.alertService.error(data.validationErrorMessage)
      return
    }

    this.alertService.success('Plan updated successfully')


    await this.refreshPlanData();
    const secondModalElement = document.getElementById('modalUpdatePlan');
    if (secondModalElement) {
      const secondModal = bootstrap.Modal.getInstance(secondModalElement);
      secondModal.hide(); // Cerrar la segunda modal
    }
  }

  async handleAssignPlanSuccess(data: any) {
    this.alert = {
      alertMessage: 'Plan assigned successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };

    //localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
    await this.refreshPlanData();
  }

  handleGetAllPlansAssignPlan(data: PlanDTO[]) {
    this.plans = data;
    this.checkFields();
  }

  minDate(): string | null {
    if (this.dateValidFrom) {
      const minDate = new Date(this.dateValidFrom);
      minDate.setDate(minDate.getDate() + 1);
      return minDate.toISOString().split('T')[0];
    }
    return null;
  }

  onRenovationChange() {
    if (!this.renovationChecked) {
      // Si Renovation se desmarca, desmarca y deshabilita Transfer
      this.transferChecked = false;
    }
  }

  exportToExcelListPlanDevices() {
    this.customerService.exportToExcelListCustomerPlans(this.userRequestDTO).subscribe(
      (response: ResponseDataFile) => {
        if (response) {
          this.handleDownload(response);
        } else {
          this.handleGetListError();
        }
      },
      (error) => {
        console.error('Error al exportar el archivo Excel:', error);
      }
    );
  }

  private handleDownload(data: ResponseDataFile) {
    const byteCharacters = atob(data.Data.fileContents);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: data.Data.contentType });
    saveAs(blob, data.Data.fileDownloadName || 'export.xlsx');

    this.alert = {
      alertMessage: 'File generated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
  }

  private handleGetListError() {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  // Método para abrir la segunda modal desde la primera modal
  openConfirmationModalUpdate() {
    // Abrir el segundo modal (Confirmation Update)
    const secondModalElement = document.getElementById('confirmationUpdate');
    if (secondModalElement) {
      const secondModal = new bootstrap.Modal(secondModalElement);
      secondModal.show();
    }
  }

  // Método para verificar si la fecha está diligenciada y es válida
  isFiledsValid(): boolean {
    if (this.planSelected == 0 ||
      (this.dateValidUntil === undefined || String(this.dateValidUntil).trim() === '')) {
      this.isValidProrating = false;
    }
    else {
      this.isValidProrating = true;
    }
    //this.prorationInitial = 0;
    return this.isValidProrating;
  }

  async handleGetProratingStartSuccess(data: SimpleValueDecimal) {
    this.prorationFinal = data.value;
  }

  onInputChange() {
    this.prorationFinal = undefined;
  }

  calculateProration() {
    this.userPlanDev.aUserPlanId = this.selectedPlanDev.idusrplndev;
    this.userPlanDev.aPlanId = this.planSelected !== undefined ? parseInt(this.planSelected.toString()) : undefined;
    this.userPlanDev.aDiscount = this.discount != null ? parseFloat(this.discount.toString().replace(/[\$,]/g, '').replace(/\,/g, '.')) : undefined;
    this.userPlanDev.aTypeDiscount = this.typeDiscount;
    this.userPlanDev.aValidFrom = this.dateValidFrom !== undefined ? new Date(this.dateValidFrom) : undefined;
    this.userPlanDev.aValidUntil = this.dateValidUntil !== undefined ? new Date(this.dateValidUntil) : undefined;
    this.userPlanDev.aDescription = this.description;
    this.userPlanDev.aDeviceId = undefined;
    this.userPlanDev.aUserId = this.selectedPlanDev.userId;
    this.userPlanDev.renovationChecked = this.renovationChecked;
    this.userPlanDev.transferDataChecked = this.transferChecked;

    this.billingService.calculateProrationEnd(this.userPlanDev).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleGetProratingEndtSuccess(Data)
          : this.handleError(StatusCode),
      (error) => {
        this.clearFields();
      }
    );
  }

  async handleGetProratingEndtSuccess(data: SimpleValueDecimal) {
    this.prorationFinal = data.value;
  }


    closeModal(): void {
      const modalElement = document.getElementById('configurationsModal');
      if (modalElement) {
        const modalInstance = bootstrap.Modal.getInstance(modalElement);
        if (modalInstance) {
          modalInstance.hide(); // Cerrar el modal
        }
      }
  
      // Asegurarse de que el fondo oscuro (backdrop) se elimina
      const modalBackdrop = document.querySelector('.modal-backdrop');
      if (modalBackdrop) {
        modalBackdrop.remove(); // Remover el fondo oscuro manualmente
      }
  
      // También asegurarnos de que se elimine la clase `modal-open` del body
      document.body.classList.remove('modal-open');
    }
  
    // Método para actualizar el valor del rango
    updateValue(event: Event): void {
      const inputElement = event.target as HTMLInputElement;
      //this.selectedValue = Number(inputElement.value); // Actualiza el valor seleccionado
    }
  
    updatePlansPercentage() {
      //const destroyed = new Subject();
      let  request = this.plansCustomer.map(plan => ({
        userPlanId: plan.idusrplndev,
        alertSendPercentage: plan.alertSendPercentage
      }));
  
      this.customerService
        .updateUserPercentageAlert(request as any)
        .subscribe(
          ({ StatusCode, Message, Data }) => {
            if (Data != null) {
               this.loadCustomerPlans();
              this.alertService.success('Plans updated successfully');
            }
          },
          (error) => {
          
            this.alertService.error('Unexpected error. Please try again later.');
              
            
          }
        );
  
      this.closeModal();
    }

    onToggleChange(event: any, plan: PlanByUserDTO) {
      debugger
      const request : any = {
        userPlanId: plan.idusrplndev ?? 0,
        sendThresholdConsumptionAlert : event.target.checked ?? false
      }

      this.customerService
      .UpdateSendThresholdConsumptionAlert(request)
      .subscribe(
        (reponse : ResponseBase) => {
          if (reponse.validationErrorMessage) {
            this.alertService.error(reponse.validationErrorMessage)
            return
          }

          this.alertService.success('Threshold usage alert updated successfully')

          //this.loadCustomerPlans();
        }
      );    
      if (event.checked) {
        console.log('Feature is enabled');
      } else {
        console.log('Feature is disabled');
      }
    }
}
